export default "__VITE_ASSET__Dyo9PJCH__"